const eligibleProp = (propObj) => (propValue) => Object.values(propObj).includes(propValue);
const EmptyOrEligibleProp = (propObj) => (propValue) => !propValue || eligibleProp(propObj)(propValue);

export {
    eligibleProp,
    EmptyOrEligibleProp
}